import { Button } from '@uswitch/spark'
import { UswArrowLargeRight } from '@uswitch/spark-icons/usw'
import React, { Fragment } from 'react'
import { useQuery } from 'urql'

import PromoSlot from '../promo-slot'
import BROADBAND_AND_TV_DEALS_QUERY from '~/graphql/queries/broadband-and-tv-deals'

import * as styles from './deal-group-styles'

const DEALS_COUNT = 3

const useTVDealsFeed = (count) => {
  const [{ error, data }] = useQuery({
    query: BROADBAND_AND_TV_DEALS_QUERY,
    variables: {
      limit: count,
      broadbandTVFilters: { dealType: ['BROADBAND_AND_TV'] }
    },
    requestPolicy: 'cache-first'
  })

  if (error) {
    throw new Error(`Deals data missing: ${error}`)
  }

  const { broadbandTVDealsFeed, broadbandTVDealsCount } = data

  return {
    feed: broadbandTVDealsFeed,
    intent: ['TV_PURCHASES'],
    copy: `Showing ${count} of ${broadbandTVDealsCount.count} from our best TV and broadband packages.`
  }
}

const BroadbandDealGroup = ({ count = DEALS_COUNT, ctaLabel, ctaLink }) => {
  const { feed, copy, intent } = useTVDealsFeed(count)

  return (
    <Fragment>
      <div sx={styles.count}>{copy}</div>
      <PromoSlot dealsFeed={feed} intent={intent} />
      <div sx={styles.ctaBox}>
        <div sx={styles.ctaHelpText}>Check availability in your area</div>
        <Button
          as='a'
          variant='secondary'
          size='large'
          rightIcon={<UswArrowLargeRight />}
          href={ctaLink}
          sx={styles.cta}
          data-action='click->tracking#trackSegment'
          data-tracking-event-param='Element Clicked'
          data-tracking-properties-param={JSON.stringify({
            element_name: ctaLabel,
            element_text: ctaLabel,
            element_type: 'button'
          })}
        >
          {ctaLabel}
        </Button>
      </div>
      <div sx={{ clear: 'both' }}> </div>
    </Fragment>
  )
}

export default BroadbandDealGroup
